<template>
  <standard-dialog
    v-model="model"
    :max-width="350"
    icon="mdi-content-copy"
    :title="$t('copy_menu_to')"
    :save-text="$t('copy')"
    :disabled="isCurrentDateSelected"
    @save="copyMenu"
  >
    <v-date-picker
      :picker-date.sync="pickerDate"
      v-model="selectedDate"
      :events="existingMenuDates"
      event-color="success"
      :loading="isLoadingMenus"
      class="ordera-box-shadow"
      full-width
      no-title
    >
    </v-date-picker>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import moment from "moment";
import menuService from "@/services/menu";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "MenuCopyDialog",
  mixins: [hasModel],
  props: {
    currentDate: {
      type: String,
      default: null,
    },
  },
  components: {
    StandardDialog,
  },
  data() {
    return {
      selectedDate: null,
      pickerDate: null,
      existingMenus: [], // API data will be stored here
      isLoadingMenus: false,
    };
  },
  computed: {
    existingMenuDates() {
      // Extract dates from API response and convert to array format that v-date-picker expects
      return this.existingMenus.map((menu) => menu.date);
    },
    isCurrentDateSelected() {
      // Disable copy button if current date is selected
      return this.selectedDate === this.currentDate;
    },
  },
  watch: {
    model(isOpen) {
      if (isOpen) {
        this.selectedDate = this.currentDate;
        this.loadExistingMenus();
      } else {
        this.selectedDate = null;
      }
    },
    pickerDate(newDate) {
      // When user navigates to different month, load menus for that month
      if (newDate) {
        this.loadExistingMenus(newDate);
      }
    },
  },
  methods: {
    copyMenu() {
      if (this.selectedDate && !this.isCurrentDateSelected) {
        this.$emit("copy", this.selectedDate);
        this.model = false;
      }
    },
    loadExistingMenus(monthYear = null) {
      // Use provided month/year or default to current selected date
      const targetDate = monthYear || this.selectedDate || moment().format("YYYY-MM-DD");
      const startOfMonth = moment(targetDate).startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment(targetDate).endOf("month").format("YYYY-MM-DD");

      this.isLoadingMenus = true;
      menuService
        .getWebAppOnlyMenu(startOfMonth, endOfMonth)
        .then((response) => {
          this.existingMenus = response.data || [];
        })
        .catch((error) => {
          console.error("Error loading existing menus:", error);
          this.existingMenus = [];
        })
        .finally(() => {
          this.isLoadingMenus = false;
        });
    },
  },
};
</script>

<style scoped>
/* Native Vuetify event styling is used instead of custom CSS */
</style>
